export default "__VITE_ASSET__a37d7b96__"